<script setup>
import {ref} from "vue";
import { useField, useFormContext } from "vee-validate";

const {values} = useFormContext();

const {value: victimIdCardFile, errorMessage: victimIdCardFileError} = useField("victim_id_card");
const {value: vehicleRegistrationCertificateFile, errorMessage: vehicleRegistrationCertificateFileError} = useField("vehicle_registration_certificate");
const {value: powerOfAttorneyRepresentativeFile, errorMessage: powerOfAttorneyRepresentativeFileError} = useField("power_of_attorney_representative");
const {value: waybillOrDrivingPermitFile, errorMessage: waybillOrDrivingPermitFileError} = useField("waybill_or_driving_permit");
const {value: policeReportOrCourtDecisionFile, errorMessage: policeReportOrCourtDecisionFileError} = useField("police_report_or_court_decision");
const {value: medicalExaminationReportFile, errorMessage: medicalExaminationReportFileError} = useField("medical_examination_report");
const {value: driverLicenseFile, errorMessage: driverLicenseFileError} = useField("driver_license");

const victimIdCardFileInput = ref(null);
const vehicleRegistrationCertificateFileInput = ref(null);
const powerOfAttorneyRepresentativeFileInput = ref(null);
const waybillOrDrivingPermitFileInput = ref(null);
const policeReportOrCourtDecisionFileInput = ref(null);
const medicalExaminationReportFileInput = ref(null);
const driverLicenseFileInput = ref(null);
</script>

<template>
    <div class="files-block">
        <h2 class="files-block-title">
            Вложения
        </h2>

        <ul class="upload-files">
            <li class="upload-files-item">
                <p class="upload-files-text">Удостоверение личности потерпевшего <span class="required-file">*</span></p>
                <button 
                    class="upload-files-button"
                    :class="victimIdCardFileError ? 'error' : ''"
                    @click="victimIdCardFileInput.click()"
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="victimIdCardFileInput"
                    @change="(event) => victimIdCardFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="victimIdCardFile">Загружено: {{ victimIdCardFile.name }}</span>
                <span v-if="victimIdCardFileError">{{ victimIdCardFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Тех. паспорт транспортного средства <span class="required-file">*</span></p>
                <button 
                    class="upload-files-button"
                    :class="vehicleRegistrationCertificateFileError ? 'error' : ''"
                    @click="vehicleRegistrationCertificateFileInput.click()" 
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="vehicleRegistrationCertificateFileInput"
                    @change="(event) => vehicleRegistrationCertificateFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="vehicleRegistrationCertificateFile">Загружено: {{ vehicleRegistrationCertificateFile.name }}</span>
                <span v-if="vehicleRegistrationCertificateFileError">{{ vehicleRegistrationCertificateFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Водительское удостоверение <span class="required-file">*</span></p>
                <button 
                    class="upload-files-button"
                    :class="driverLicenseFileError ? 'error' : ''"
                    @click="driverLicenseFileInput.click()" 
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="driverLicenseFileInput"
                    @change="(event) => driverLicenseFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="driverLicenseFile">Загружено: {{ driverLicenseFile.name }}</span>
                <span v-if="driverLicenseFileError">{{ driverLicenseFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Доверенность на представление интересов <span class="required-file">*</span></p>
                <button 
                    class="upload-files-button"
                    :class="powerOfAttorneyRepresentativeFileError ? 'error' : ''"
                    @click="powerOfAttorneyRepresentativeFileInput.click()"
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="powerOfAttorneyRepresentativeFileInput"
                    @change="(event) => powerOfAttorneyRepresentativeFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input" 
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="powerOfAttorneyRepresentativeFile">Загружено: {{ powerOfAttorneyRepresentativeFile.name }}</span>
                <span v-if="powerOfAttorneyRepresentativeFileError">{{ powerOfAttorneyRepresentativeFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Путевой лист/ Доверенность на управление ТС на водителя <span class="required-file">*</span></p>
                <button 
                    class="upload-files-button"
                    :class="waybillOrDrivingPermitFileError ? 'error' : ''"
                    @click="waybillOrDrivingPermitFileInput.click()"
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="waybillOrDrivingPermitFileInput"
                    @change="(event) => waybillOrDrivingPermitFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="waybillOrDrivingPermitFile">Загружено: {{ waybillOrDrivingPermitFile.name }}</span>
                <span v-if="waybillOrDrivingPermitFileError">{{ waybillOrDrivingPermitFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Материалы ГАИ/Постановление суда при наличии</p>
                <button 
                    class="upload-files-button"
                    :class="policeReportOrCourtDecisionFileError ? 'error' : ''"
                    @click="policeReportOrCourtDecisionFileInput.click()"
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="policeReportOrCourtDecisionFileInput"
                    @change="(event) => policeReportOrCourtDecisionFile = event.target.files[0]"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="policeReportOrCourtDecisionFile">Загружено: {{ policeReportOrCourtDecisionFile.name }}</span>
                <span v-if="policeReportOrCourtDecisionFileError">{{ policeReportOrCourtDecisionFileError }}</span>
            </li>

            <li class="upload-files-item">
                <p class="upload-files-text">Заключение медицинского освидетельствования</p>
                <button 
                    class="upload-files-button"
                    :class="medicalExaminationReportFileError ? 'error' : ''"
                    @click="medicalExaminationReportFileInput.click()"
                    type="button"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z" fill="#007BFF"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V9H5C4.73478 9 4.48043 9.10536 4.29289 9.29289C4.10536 9.48043 4 9.73478 4 10C4 10.2652 4.10536 10.5196 4.29289 10.7071C4.48043 10.8946 4.73478 11 5 11H9V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V11H15C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10C16 9.73478 15.8946 9.48043 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9H11V5Z" fill="#007BFF"/>
                    </svg>
                    Прикрепить файл
                </button>
                <input
                    ref="medicalExaminationReportFileInput"
                    @change="(event) => {medicalExaminationReportFile = event.target.files[0]; console.log(values)}"
                    type="file" 
                    class="upload-files-input"
                    accept="application/pdf, image/jpeg, image/png, image/jpg, .doc, .docx"
                />

                <span class="success-uploaded-file" v-if="medicalExaminationReportFile">Загружено: {{ medicalExaminationReportFile.name }}</span>
                <span v-if="medicalExaminationReportFileError">{{ medicalExaminationReportFileError }}</span>
            </li>
        </ul>
    </div>
</template>

<style scoped>
.files-block {
    margin-top: 60px;
}

.files-block-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    color: #151515;

    font-family: "Roboto", sans-serif;
}

.upload-files {
    list-style-type: none;
    margin-top: 30px;
}

.upload-files-item {
    position: relative;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.success-uploaded-file {
    color: green;
    margin-top: 5px;
}

.upload-files-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
    cursor: pointer;
}

.upload-files-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 31px;
    color: #151515;

    font-family: "Roboto", sans-serif;

    margin-bottom: 10px;
}

.upload-files-button {
    width: 310px;
    padding: 17.5px 0;

    border: 2px solid #007BFF;
    border-radius: 8px;
    background-color: transparent;

    font-size: 16px;
    font-weight: 400;
    color: #007BFF;

    cursor: pointer;

    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    transition: all .1s ease-in-out;

    & svg path {
        transition: all .1s ease-in-out;
    }

    &:hover {
        color: white;
        background-color: #007BFF;

        & svg path {
            fill: white;
        }
    }
}

.required-file {
    color: #007BFF;
}
</style>